import React, { useState, useEffect } from 'react'
import Classes from './Invoices.module.css'
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Invoices() {
    const initialinvoices = [
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Paid" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Overdue" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Paid" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Overdue" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Pending" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Paid" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Paid" },
        { "Invoice": "Website Audit", "Date": "March 1, 2025", "DateDue": "March 3, 2025", "Total": "$400.00", "Status": "Pending" }
    ]

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(initialinvoices.length / itemsPerPage);
    const currentItems = initialinvoices.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialinvoices.length);
    const totalItems = initialinvoices.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-invoice');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3>Invoices</h3>
                    <h5>Manage your invoices.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <div className={Classes.table} >
                <div className={Classes.tableWrapper}>

                    <div className={Classes.tableHeader}>
                        <div className={`${Classes.headerItem} ${Classes.header1}`}>
                            <h5>#</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header2}`}>
                            <h5>Invoice</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header3}`}>
                            <h5>Date</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header4}`}>
                            <h5>Date Due</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header5}`}>
                            <h5>Total</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header6}`}>
                            <h5>Status</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header7}`} >
                            {/* <h5>Number</h5> */}
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header8}`} />
                    </div>

                    <div className={Classes.tableBody}>
                        {loading ? (
                            <SkeletonLoading
                                length={itemsPerPage}
                                height={isMobile ? '6rem' : '2.8rem'}
                                width="100%"
                                br="6px"
                            />
                        ) : currentItems && currentItems.length > 0 ? (
                            currentItems.map((cust, idx) => (
                                <TableRow
                                    key={cust._id}
                                    value={cust}
                                    index={idx}
                                />
                            ))
                        ) : (
                            <div>No invoice found.</div>
                        )}
                    </div>

                    <div className={Classes.pagFooter}>
                        <h5 style={{ height: '1.2rem' }}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                                : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                            }
                        </h5>
                        <Stack spacing={2} className={Classes.pagination}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                                : <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    shape="rounded"
                                />
                            }
                        </Stack>
                    </div>
                </div>
            </div>
        </div>
    )
}
